import React, { Component } from 'react'
import { CButton, CCard, CCardBody, CCardGroup, CCol, CContainer, CForm, CInput, CInputGroup, CInputGroupPrepend, CInputGroupText, CRow } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { authWrapper } from '../../../auth/AuthWrapper'
import logo from '../../../../src/uploads/images/gov-logo.jpg'
//import { officeInfo } from '../../../utils/CommonExport'
import { TMSContext } from "../../../context/context";

const Login = (authWrapper(class extends Component {

    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            errorMessage: null
        }
    }

    static contextType = TMSContext;

    authenticate = (event) => {
        const credentials = { username: this.state.username, password: this.state.password };

        if (credentials.username === '') {
            event.preventDefault();
            return false;
        } else {
            event.preventDefault();
            this.props.authenticate(credentials)
                .then(() => this.props.history.push("/"))
                .catch(err => this.setState({ errorMessage: "username or password doesn't match." }, () => console.error(err)));
        }
    }

    onInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    render() {
        //<CRow className="justify-content-center">
        var width = window.innerWidth;
        const { CompanyInfo } = this.context;
        return (
            <div className="c-app c-default-layout flex-row align-items-center homepage-bgimage">
                <CContainer>
                    <CRow>
                        <CCol md="4">
                            <CCardGroup style={{ opacity: width < 500 ? 0.9 : 1.0 }}>
                                <CCard className="p-3">
                                    <CCardBody>
                                        <CForm>
                                            <div className="auth-logo text-center mb-3">
                                                <img src={logo} alt="logo" />
                                            </div>
                                            {width > 500 ?
                                                <>
                                                    <h3 className="text-center">{CompanyInfo.name}</h3>
                                                    <h4 className="text-center">{CompanyInfo.title}</h4>
                                                    <h4 className="text-center">{CompanyInfo.subtitle}</h4>
                                                    <p className="text-muted">Sign In to your account</p>
                                                </>
                                                :
                                                <>
                                                    <h5 className="text-center">{CompanyInfo.name}</h5>
                                                    <h6 className="text-center">{CompanyInfo.title}</h6>
                                                    <h6 className="text-center">{CompanyInfo.subtitle}</h6>
                                                    <p className="text-muted text-center">टिकटिंग व्यवस्थापन प्रणाली</p>
                                                </>
                                            }
                                            {this.state.errorMessage != null &&
                                                <h6 className="bg-danger text-center text-white m-1 p-2" style={{ borderRadius: "5px" }}>
                                                    {this.state.errorMessage}
                                                </h6>
                                            }
                                            <CInputGroup className="mb-3">
                                                <CInputGroupPrepend>
                                                    <CInputGroupText>
                                                        <CIcon name="cil-user" />
                                                    </CInputGroupText>
                                                </CInputGroupPrepend>
                                                <CInput id="username" name="username" type="text" placeholder="Username" autoComplete="username"
                                                    onChange={this.onInputChange} value={this.state.username} />
                                            </CInputGroup>
                                            <CInputGroup className="mb-4">
                                                <CInputGroupPrepend>
                                                    <CInputGroupText>
                                                        <CIcon name="cil-lock-locked" />
                                                    </CInputGroupText>
                                                </CInputGroupPrepend>
                                                <CInput id="password" name="password" type="password" placeholder="Password" autoComplete="current-password"
                                                    onChange={this.onInputChange} value={this.state.password} />
                                            </CInputGroup>
                                            <CRow>
                                                <CCol xs="6">
                                                    <CButton color="primary" className="px-4" onClick={this.authenticate}>Login</CButton>
                                                </CCol>
                                            </CRow>
                                            <div className="text-center mt-2">
                                                <p>©२०७८ सर्वाधिकार सुरक्षित {CompanyInfo.name}</p>
                                            </div>
                                        </CForm>
                                    </CCardBody>
                                </CCard>
                            </CCardGroup>
                        </CCol>
                        {width > 500 ? <CCol md="8" className="text-right">
                            <h1 className="font-weight-700" style={{ color: "#f8f9fa" }}>टिकटिंग व्यवस्थापन प्रणाली</h1>
                            <h2 style={{ color: "#f8f9fa" }}>Ticketing Management System</h2>
                        </CCol> : ''}
                    </CRow>
                </CContainer>
            </div>
        )
        // <CCol xs="6" className="text-right" >
        //   <CButton color="link" className="px-0">Forgot password?</CButton>
        //</CCol >
    }
}))


export default Login
